import { WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";

import { getRuntimeConfig } from "./runtime-config";

const config = getRuntimeConfig();

export const authConfig: AuthProviderProps = {
  authority: config.authUri,
  client_id: config.clientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/signout-callback`,
  scope: "openid profile partner_portal_api claims_partner_services_acls",
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    // Remove the query parameters that OIDC adds to avoid clutter
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
